import React from 'react';
import './AllCategoriesLoadingScreen.css';

const AllCategoriesLoadingScreen = () => {
  return (
    <main className="all-categories-loading-main">
      {/* Categories Grid Section Skeleton */}
      <div className="all-categories-loading-grid">
        {[...Array(9)].map((_, index) => (
          <div key={index} className="all-categories-loading-card">
            <div className="all-categories-loading-overlay"></div>
            <div className="all-categories-loading-content">
              <div className="loading-category-name"></div>
              <div className="loading-category-count"></div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
};

export default AllCategoriesLoadingScreen;

